// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    DiscussionsAppliedFilter,
    DiscussionsAppliedFilterFromJSON,
    DiscussionsAppliedFilterToJSON,
} from './';

/**
 * 
 * @export
 * @interface DiscussionsSearchRequestData
 */
export interface DiscussionsSearchRequestData {
    /**
     * 
     * @type {string}
     * @memberof DiscussionsSearchRequestData
     */
    keywords?: string;
    /**
     * 
     * @type {Array<DiscussionsAppliedFilter>}
     * @memberof DiscussionsSearchRequestData
     */
    filters?: Array<DiscussionsAppliedFilter>;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsSearchRequestData
     */
    ordering?: DiscussionsSearchRequestDataOrderingEnum;
    /**
     * 
     * @type {number}
     * @memberof DiscussionsSearchRequestData
     */
    currentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionsSearchRequestData
     */
    paginationSize?: number;
}

export function DiscussionsSearchRequestDataFromJSON(json: any): DiscussionsSearchRequestData {
    return {
        'keywords': !exists(json, 'keywords') ? undefined : json['keywords'],
        'filters': !exists(json, 'filters') ? undefined : (json['filters'] as Array<any>).map(DiscussionsAppliedFilterFromJSON),
        'ordering': !exists(json, 'ordering') ? undefined : json['ordering'],
        'currentPage': !exists(json, 'current_page') ? undefined : json['current_page'],
        'paginationSize': !exists(json, 'pagination_size') ? undefined : json['pagination_size'],
    };
}

export function DiscussionsSearchRequestDataToJSON(value?: DiscussionsSearchRequestData): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'keywords': value.keywords,
        'filters': value.filters === undefined ? undefined : (value.filters as Array<any>).map(DiscussionsAppliedFilterToJSON),
        'ordering': value.ordering,
        'current_page': value.currentPage,
        'pagination_size': value.paginationSize,
    };
}

/**
* @export
* @enum {string}
*/
export enum DiscussionsSearchRequestDataOrderingEnum {
    Relevance = 'relevance',
    MostRecent = 'most_recent',
    MostLiked = 'most_liked'
}


